const KEY = "dh_agents";

function readAgents() {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
}

function writeAgents(agents) {
  localStorage.setItem(KEY, JSON.stringify(agents));
}

export function loginAgent(credentials) {
  /* POST /agents/login */
  const agent = readAgents().find(
    (item) =>
      item.email.toLowerCase() === String(credentials.email || "").toLowerCase() &&
      item.password === credentials.password
  );
  if (!agent) {
    return Promise.reject(new Error("Invalid agent credentials"));
  }
  const { password, ...safe } = agent;
  return Promise.resolve(safe);
}

export function getAgentDashboard(agentId) {
  /* GET /agents/:id/dashboard */
  const agent = readAgents().find((item) => item.id === agentId);
  if (!agent) return Promise.reject(new Error("Agent not found"));
  return Promise.resolve({
    agent: { ...agent, password: undefined },
    clientCount: (agent.clients || []).length,
  });
}

export function getAgent(id) {
  const agent = readAgents().find((item) => item.id === id) || null;
  if (agent) {
    const { password, ...safe } = agent;
    return Promise.resolve(safe);
  }
  return Promise.resolve(null);
}

export function listAgents() {
  return Promise.resolve(readAgents().map(({ password, ...rest }) => rest));
}

export function seedAgents(agents) {
  if (!readAgents().length) writeAgents(agents);
}
